import graphql__8652dee648d20b28e253 from "./__generated__/useCreateHubSpotContactMutation.graphql.ts";import graphql from 'babel-plugin-relay/macro'
import { useEffect, useState } from 'react'
import { usePortalMutation } from 'utils'

import { useCreateHubSpotContactMutation } from './__generated__/useCreateHubSpotContactMutation.graphql'

const CreateHubSpotContactMutation = graphql__8652dee648d20b28e253

/** Hook used to create HubSpot contact for a current user. */
const useCreateHubSpotContact = (viewerId: string | null = null): string => {
  const [createHubSpotContact] =
    usePortalMutation<useCreateHubSpotContactMutation>(
      CreateHubSpotContactMutation,
      {
        mutationName: 'CreateHubSpotContact',
        sentryContext: {
          component: 'useCreateHubSpotContact',
        },
        showErrorToast: false,
      },
    )
  const [contactId, setContactId] = useState('')

  useEffect(() => {
    if (viewerId) {
      createHubSpotContact({
        variables: {},
        onCompleted(data) {
          setContactId(data?.createHubspotContact?.hubspotContactId)
        },
      })
    }
  }, [viewerId]) // eslint-disable-line react-hooks/exhaustive-deps

  return contactId
}

export default useCreateHubSpotContact
